import { gql, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { LoadTable } from "../../Components";
import Select from "react-select";
import { processDataForDWMLoads } from "./prepareChartData";
import RefreshIcon from "./RefreshIcon";
import "./Dashboard.scss";

const loadPostByErpUserQuery = gql`
  query Query($timeFrame: String!) {
    getLoadPostDynamicByErpUserId(timeFrame: $timeFrame)
  }
`;

const customStyles = {
  container: (provided) => ({
    ...provided,
    width: "100px",
    marginLeft: "1%",
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: "#f0f0f0",
    border: "1px solid #ccc",
    boxShadow: "none",
    fontSize: "12px",
    padding: "0px",
    "&:hover": {
      borderColor: "#888",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#888",
    fontSize: "12px",
    padding: "0px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#999999",
    fontSize: "11px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    fontSize: "11px",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "150px",
    overflowY: "auto",
    fontSize: "11px",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#b3e5b4" : state.isFocused ? "#4caf50" : base.backgroundColor,
    color: state.isSelected || state.isFocused ? "#fff" : "#333",
    fontSize: "11px",
    "&:active": {
      backgroundColor: "#b3e5b4",
      color: "#fff",
    },
    "&:hover": {
      backgroundColor: "#4caf50",
      color: "#fff",
    },
  }),
};

const LoadPostByErpUser = () => {
  const Key = "Load_Post_By_User_Id";
  const [timeFrame, setTimeFrame] = useState({ value: "daily", label: "Daily" });
  const [TableData, setTableData] = useState([]);
  const [ColAddition, setcolAddition] = useState([]);

  const selectOptions = [
    { value: "daily", label: "Daily" },
    { value: "weekly", label: "Weekly" },
    { value: "monthly", label: "Monthly" },
  ];

  const handleSelectChange = (selectedOption) => {
    setTimeFrame(selectedOption);
  };

  const { data, loading, error, refetch } = useQuery(loadPostByErpUserQuery, {
    variables: { timeFrame: timeFrame.value },
    context: { headers: { "X-GraphQL-Server": "secondary" } },
    notifyOnNetworkStatusChange: true,
  });



  useEffect(() => {
    if (data?.getLoadPostDynamicByErpUserId) {
      const { colAddition, updatedData } = processDataForDWMLoads(data?.getLoadPostDynamicByErpUserId);
      console.log(updatedData, "updatedData", colAddition);
      setTableData(updatedData);
      setcolAddition(colAddition);
    }
  }, [data]);

  if (error) {
    return <p>Error: {error.message}</p>;
  }
  console.log(TableData)
  return (
    <>
      <div className="title_With_Loading_Logo">
        <div className="load-post-title">Load Post By Erp User</div>
        <div className="load-post-logo">
          <RefreshIcon
            handleRefetch={refetch}
            loading={loading}
            className="icon_styling delete_icon_style FiRefreshCcw"
          />
        </div>
      </div>

      <div className="Load_Post_Chart_And_Table">
        <div style={{ marginLeft: "1%" }}></div>
        <div className="Load_Post_Chart_And_Table_Child_Two" style={{ marginLeft: "2%" }}>
          <div>
            <label htmlFor="timeFrameSelect">Time Frame:</label>
          </div>
          <div>
            <Select
              value={selectOptions.value}
              onChange={handleSelectChange}
              options={selectOptions}
              placeholder={timeFrame.label}
              styles={customStyles}
            />
          </div>
        </div>
      </div>
      <div className="Account_Track_Shipments_Box">
        <LoadTable
          data={TableData}
          loading={loading}
          error={error}
          title={Key}
          settings={false}
          options={false}
          TableHeaders={ColAddition}
        />
      </div>
    </>
  );
};

export default LoadPostByErpUser;
